import React from 'react';
import { Link } from 'react-router-dom';

const Product = (props) => {
    const {image , price, title,category ,brand ,description, id } = props.product
    const {handleAddToCart} = props


    return (
        <div className="card lg:w-3/3 bg-base-300 shadow-xl">
        <figure ><img src={image} alt={title} className='max-h-96' /></figure>
        <div className="card-body">
          <h2 className="card-title">
            <Link to={`/product/${id}`}>
            {title}
            </Link>
          </h2>
          <p>{description?.slice(0,200)}</p>
          <p className='text-accent'>${price}</p>
          <div className="card-actions">
            <div className="badge badge-accent">{category}</div> 
          </div>
          <div className="card-actions my-4">
            <button className="btn btn-primary btn-block" onClick={()=> {handleAddToCart(props.product)}}>Add to Cart</button>
          </div>
        </div>
      </div>
    );
};

export default Product;